
import { defineComponent } from 'vue';

/**
 * Icone de seta.
 * @displayName IconError [Componente do UseIcon]
 */
export default defineComponent({
    name: 'IconError',
    props: {
        size: {
            type: [String, Number],
            default: 22,
        },
        color: {
            type: String,
            default: 'white',
        },
    },
});
